import { auth } from './auth';

export const sitewide = {
  auth,
};
